export class AlertMessage{
    public static readonly DANGER = 'alert-danger';
    public static readonly WARNING = 'alert-warning';
    public static readonly INFO = 'alert-info';
    public static readonly SUCCESS = 'alert-success';
}
